document.addEventListener('DOMContentLoaded', function () {
  const forms = document.querySelectorAll('[data-order-status-form]');

  if (!forms.length) {
    return;
  }

  // translations
  const checkingText = window.theme?.additionalTranslations?.checking;
  const incorrectOrderText = window.theme?.additionalTranslations?.incorrect_order;
  const incorrectEmailText = window.theme?.additionalTranslations?.incorrect_email;
  const archivedOrderText = window.theme?.additionalTranslations?.archived_order;
  const processedOrderText = window.theme?.additionalTranslations?.processed_order;
  const delayedOrderText = window.theme?.additionalTranslations?.delayed_order;
  const deliveryText1 = window.theme?.additionalTranslations?.delivery_text_1;
  const deliveryText2 = window.theme?.additionalTranslations?.delivery_text_2;
  const deliveryText3 = window.theme?.additionalTranslations?.delivery_text_3;
  const orderStatus = window.theme?.additionalTranslations?.order_status;
  const orderNote = window.theme?.additionalTranslations?.order_note;
  const orderNote2 = window.theme?.additionalTranslations?.order_note_2;
  const cancelOrderText =
    window.theme?.additionalTranslations?.cancel_order || 'Anuluj zamówienie';

  const CANCEL_SECTION_KEY = 'section_accordion_group_FnYMQt';
  const CANCEL_ACCORDION_TITLE = 'Chcę anulować moje zamówienie';

  function findCancelSection() {
    return (
      document.getElementById('shopify-section-' + CANCEL_SECTION_KEY) ||
      document.querySelector(
        '[id^="shopify-section-"][id$="' + CANCEL_SECTION_KEY + '"]'
      )
    );
  }

  function findAccordionHeader(section) {
    const normalize = (s) => (s || '').replace(/\s+/g, ' ').trim().toLowerCase();
    const target = normalize(CANCEL_ACCORDION_TITLE);

    const candidates = section.querySelectorAll(
      '[data-collapsible-trigger], summary, [aria-expanded], [role="button"], .accordion__title, h2, h3, h4'
    );

    for (const el of candidates) {
      if (normalize(el.textContent).includes(target)) {
        return el;
      }
    }
    return null;
  }

  function openAccordion(header) {
    const details = header.closest('details');

    const trigger =
      (details && details.querySelector('[data-collapsible-trigger], summary')) ||
      header.closest('[aria-expanded], [role="button"], summary') ||
      header;

    const isOpen =
      (details && details.hasAttribute('open')) ||
      trigger.getAttribute('aria-expanded') === 'true';

    if (!isOpen) {
      trigger.click();
    }
  }

  function goToCancelForm() {
    const section = findCancelSection();
    if (!section) {
      console.warn('Nie znaleziono sekcji anulacji:', CANCEL_SECTION_KEY);
      return;
    }

    const header = findAccordionHeader(section);
    let scrollTarget = section;

    if (header) {
      openAccordion(header);
      scrollTarget = header.closest('details, .accordion, li') || header;
    } else {
      console.warn(
        'Nie znaleziono nagłówka accordionu:',
        CANCEL_ACCORDION_TITLE,
        '— przewijam do sekcji.'
      );
    }

    scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /**
   * Binds a single order status widget so multiple widgets can live on one page.
   *
   * @param {HTMLFormElement} form - Order status form element.
   * @returns {void}
   */
  function bindForm(form) {
    const widget = form.closest('[data-order-status-root]') || form.parentElement;
    const showCancelButton = widget && widget.dataset.showCancel === 'true';

    let resultBox = widget && widget.querySelector('[data-order-status-result]');
    if (!resultBox) {
      resultBox = document.createElement('div');
      resultBox.className = 'at-order-status__status';
      resultBox.setAttribute('data-order-status-result', '');
      resultBox.style.display = 'none';
      form.insertAdjacentElement('afterend', resultBox);
    }

    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      const orderNumber = form.querySelector('[name="orderNumber"]').value.trim();
      const email = form.querySelector('[name="email"]').value.trim();

      resultBox.style.display = 'block';
      resultBox.innerHTML = checkingText;

      try {
        const response = await fetch('https://vps-57b8362a.vps.ovh.net/api/check-order', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            orderNumber,
            email,
          }),
        });

        const data = await response.json();

        if (!response.ok || !data.success) {
          let errorDetails = '';

          if (!data.isOrderNumberCorrect) {
            errorDetails += incorrectOrderText;
          }

          if (!data.isEmailCorrect) {
            errorDetails += incorrectEmailText;
          }

          resultBox.innerHTML = `
            <strong>Error:</strong> ${errorDetails}
          `;
          resultBox.style.display = 'block';
          return;
        }

        let deliveryText = '';
        let message = '';

        if (data.status === 'archived') {
          message = archivedOrderText;
        } else if (data.status === 'processing' && !data.isDelayed) {
          message = processedOrderText;
        } else if (data.isDelayed) {
          message = delayedOrderText;
        }

        if (data.deliveryFrom === data.deliveryTo && !data.isOrderArchived) {
          deliveryText = `<p>${deliveryText1} ${deliveryText3} <b>${data.deliveryTo}</b>.</p>`;
        } else if (data.isOrderArchived) {
          deliveryText = '';
        } else {
          deliveryText = `<p>${deliveryText2} <b>${data.deliveryFrom}</b> ${deliveryText3} <b>${data.deliveryTo}</b>.</p>`;
        }

        const canCancel =
          showCancelButton &&
          !data.isOrderArchived &&
          data.status !== 'cancelled' &&
          data.status !== 'shipped';

        const cancelButton = canCancel
          ? `<button type="button" class="btn btn--primary btn--solid btn--small at-order-status__cancel" style="margin-top:16px;display:inline-block;width:auto;">${cancelOrderText}</button>`
          : '';

        resultBox.innerHTML = `
          <strong>${orderStatus} ${orderNumber}</strong>
          <p>${orderStatus}: <b>${message}</b></p>
          ${deliveryText}
          ${!data.isOrderArchived ? `<p class="note">${data.isDelayed ? orderNote2 : orderNote}</p>` : ''}
          ${cancelButton}
        `;

        const cancelBtn = resultBox.querySelector('.at-order-status__cancel');
        if (cancelBtn) {
          cancelBtn.addEventListener('click', goToCancelForm);
        }

        if (widget) {
          widget.dispatchEvent(
            new CustomEvent('order-status:result', { bubbles: true, detail: data })
          );
        }
      } catch (err) {
        // Bez tego bloku, przy błędzie sieci/serwera (np. 502) tekst "Sprawdzanie..."
        // wisiałby w nieskończoność, bo nic go nie zastępuje.
        console.error('Order status check failed:', err);
        const errorText =
          window.theme?.additionalTranslations?.request_error ||
          'Wystąpił błąd podczas sprawdzania statusu zamówienia. Spróbuj ponownie później.';
        resultBox.innerHTML = `<strong>Error:</strong> ${errorText}`;
        resultBox.style.display = 'block';
      }
    });
  }

  for (let i = 0; i < forms.length; i += 1) {
    bindForm(forms[i]);
  }
});
